// extracted by mini-css-extract-plugin
export default {"wrapper":"StageWidget_wrapper__ajBM+"};